(function(){
  "use strict";

  function initAccordions(root){
    root.querySelectorAll('.hmh-acc-head').forEach(function(h){
      h.addEventListener('click',function(){
        var item=h.parentElement;
        item.classList.toggle('open');
        var sym=h.querySelector('.sym');
        if(sym) sym.innerHTML = item.classList.contains('open') ? '&minus;' : '+';
      });
    });
  }

  function initReviewSlider(root){
    var el=root.querySelector('[data-hmh-review-slider]');
    if(!el) return;
    var down=false,startX=0,startScroll=0,moved=false;
    el.addEventListener('pointerdown',function(e){ down=true; moved=false; startX=e.clientX; startScroll=el.scrollLeft; el.classList.add('dragging'); });
    window.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-startX;
      if(Math.abs(dx)>3) moved=true;
      el.scrollLeft=startScroll-dx;
    });
    window.addEventListener('pointerup',function(){ if(!down) return; down=false; el.classList.remove('dragging'); });
    el.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } },true);
  }

  function money(cents,fmt){
    fmt = fmt || '${{amount}}';
    var m = fmt.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var token = m ? m[1] : 'amount';
    var v = cents/100;
    var dec = 2, thou = ',', point = '.';
    if(token.indexOf('with_comma_separator') > -1){ thou='.'; point=','; }
    if(token.indexOf('no_decimals') > -1) dec = 0;
    var fixed = v.toFixed(dec);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var out = dec > 0 ? intPart + point + parts[1] : intPart;
    return m ? fmt.replace(m[0], out) : fmt + out;
  }

  function initOffers(root){
    var cards=Array.prototype.slice.call(root.querySelectorAll('[data-hmh-offer]'));
    if(!cards.length) return;
    var fmt=root.getAttribute('data-hmh-money')||'${{amount}}';
    var idInput=root.querySelector('[data-hmh-variant-input]');
    var nowEls=root.querySelectorAll('[data-hmh-price-now]');
    var wasEls=root.querySelectorAll('[data-hmh-price-was]');
    var atcBtns=root.querySelectorAll('[data-hmh-atc]');
    function apply(card){
      cards.forEach(function(c){ c.classList.remove('selected'); });
      card.classList.add('selected');
      var vid=card.getAttribute('data-variant-id');
      var price=parseInt(card.getAttribute('data-price'),10);
      var compare=parseInt(card.getAttribute('data-compare'),10)||0;
      if(idInput) idInput.value=vid;
      nowEls.forEach(function(el){ el.textContent=money(price,fmt); });
      wasEls.forEach(function(el){
        if(compare>price){ el.textContent=money(compare,fmt); el.style.display=''; }
        else el.style.display='none';
      });
      var available=card.getAttribute('data-available')!=='false';
      atcBtns.forEach(function(btn){ btn.disabled=!available; btn.textContent=available?(btn.getAttribute('data-label')||'PEDIR AHORA'):'AGOTADO'; });
    }
    cards.forEach(function(c){ c.addEventListener('click',function(){ apply(c); }); });
    var pre=cards.filter(function(c){ return c.classList.contains('selected'); })[0] || cards[0];
    if(pre) apply(pre);
  }

  function initLightbox(root){
    var box=root.querySelector('.hmh-lightbox');
    if(!box) return;
    var img=box.querySelector('img');
    var imgs=Array.prototype.slice.call(root.querySelectorAll('[data-hmh-zoom]'));
    imgs.forEach(function(el){ el.addEventListener('click',function(){ img.src=el.src; box.classList.add('open'); }); });
    box.querySelector('.close').addEventListener('click',function(){ box.classList.remove('open'); });
    box.addEventListener('click',function(e){ if(e.target===box) box.classList.remove('open'); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') box.classList.remove('open'); });
  }

  function initCountdown(root){
    var el=root.querySelector('[data-hmh-countdown]');
    if(!el) return;
    var key='hmhDeadline';
    var end=parseInt(localStorage.getItem(key)||'0',10);
    if(!end||end<Date.now()){ end=Date.now()+1000*60*60*8; localStorage.setItem(key,String(end)); }
    function tick(){
      var d=Math.max(0,end-Date.now());
      var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      function p(n){return n<10?'0'+n:''+n;}
      el.textContent=p(h)+':'+p(m)+':'+p(s);
    }
    tick(); setInterval(tick,1000);
  }

  function initPopup(root){
    var el=root.querySelector('[data-hmh-popup]');
    if(!el) return;
    var buyers=[
      {name:'Mar\u00eda',city:'Ciudad de Guatemala'},
      {name:'Rosa',city:'Quetzaltenango'},
      {name:'Carlos',city:'Mixco'},
      {name:'Ana',city:'Villa Nueva'},
      {name:'Pedro',city:'Antigua Guatemala'}
    ];
    var txtEl=el.querySelector('[data-hmh-popup-text]');
    var closed=false,i=0;
    function show(){
      if(closed) return;
      var b=buyers[i%buyers.length];
      txtEl.innerHTML='<b>'+b.name+'</b> de '+b.city+' compr\u00f3 <b>HEM HERO</b>';
      el.classList.add('show'); i++;
      setTimeout(function(){ el.classList.remove('show'); },5000);
    }
    el.querySelector('[data-hmh-popup-close]').addEventListener('click',function(){ closed=true; el.classList.remove('show'); });
    setTimeout(show,4000);
    setInterval(function(){ if(!el.classList.contains('show')) show(); },14000);
  }

  function init(){
    document.querySelectorAll('.hmh[data-hmh-root]').forEach(function(root){
      initAccordions(root);
      initReviewSlider(root);
      initOffers(root);
      initCountdown(root);
      initPopup(root);
      initLightbox(root);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
